module.exports = __webpack_public_path__ + "img/otr-leasing.0b5c6c6d.png";